export default __webpack_public_path__ + "static/tablet-04a41a03fb4d23d9876c543947f41129.webp";